import moment from 'moment'

export default {
  namespaced: true,

  state: () => ({
    products: {
      data: [],
      links: {},
      meta: {},
    },
    emptyProducts: {
      data: [],
      links: {},
      meta: {},
    },
    productStocks: {
      data: [],
      links: {},
      meta: {},
    },
    productRegistries: {
      data: [],
      links: {},
      meta: {},
    },
    externalProducts: {
      data: [],
      links: {},
      meta: {},
    },
    product: {},
    isLoading: false,
    isLoadingDashboard: false,
    isLoadingSubmit: false,
    isShowEditProductExternal: false,
    isShowSwitchProductExternal: false,
    isShowDoNotSwitchProductExternal: false,
    productGrowth: {
      statistic: [],
    },
    skuGrowth: {
      statistic: [],
    },
    emptyResultSearch: [],
    topSearch: [],
    topResult: [],
    skus: [],
    switchExternal: {
      product: '',
      variant: '',
    },
    productsSearch: [],
    productsMetaSearch: {},
    startIndex: 0,
    labelForm: {
      merchant: {
        title: 'Merchant',
        description: [
          'Pilih merchant/brand mana produk ini akan dimasukkan.',
          'Merchant yang dipilih dapat mengubah produk ini nantinya. Merchant tersebut juga dapat mengelola transaksi apabila produk tersebut dibeli oleh seseorang.',
        ],
      },
      image: {
        title: 'Gambar Produk',
        description: [
          'Format gambar .jpg .jpeg .png dan ukuran minimum 300 x 300px (Untuk gambar optimal gunakan ukuran minimum 700 x 700 px).',
          'Pilih foto produk atau tarik dan letakkan hingga 5 foto sekaligus di sini. Cantumkan min. 3 foto yang menarik agar produk semakin menarik pembeli.',
        ],
      },
      name: {
        title: 'Nama Produk',
        description: [
          'Cantumkan min. 40 karakter agar semakin menarik dan mudah ditemukan oleh pembeli, terdiri dari jenis produk, merek, dan keterangan seperti warna, bahan, atau tipe.',
        ],
      },
      category: {
        title: 'Kategori Produk',
        description: [
          'Pilih kategori yang sesuai agar produkmu mudah ditemukan. Jika pemilihan kategori kurang sesuai, maka kategori akan diubah oleh Miniapoly.',
        ],
      },
      description: {
        title: 'Deskripsi Produk',
        description: [
          'Tulis deskripsi produkmu min. 260 karakter agar pembeli semakin mudah mengerti.',
          'Pastikan deskripsi produk memuat penjelasan detail terkait produkmu agar pembeli mudah mengerti dan menemukan produkmu.',
        ],
      },
      keyword: {
        title: 'Keyword',
        description: [
          'Digunakan untuk meningkatkan akurasi dalam pencarian produk.',
        ],
      },
      sku: {
        title: 'Kode SKU',
        description: ['Gunakan kode unik SKU(Stock Keeping Unit) jika kamu ingin menandai produkmu.'],
      },
      price: {
        title: 'Harga Awal',
        description: ['Harga produk sebelum diskon.'],
      },
      discountPrice: {
        title: 'Harga Diskon',
        description: ['Tulis harga diskon apabila ada harga diskon atau harga coret.'],
      },
      weight: {
        title: 'Berat',
        description: ['Masukkan berat dengan menimbang <b>produk setelah dikemas</b>.'],
      },
      stock: {
        title: 'Jumlah Stok',
        description: ['Pastikan jumlah stok produk sesuai dan selalu diperbaharui.'],
      },
      gender: {
        title: 'Jenis Kelamin',
        description: ['Pilih jenis kelamin anak yang tepat untuk menggunakan produk ini.'],
      },
      age: {
        title: 'Usia',
        description: ['Pilih rentang usia anak yang cocok untuk menggunakan produk ini.'],
      },
      available: {
        title: 'Status',
        description: ['Atur sebagai tidak tersedia untuk membuat produk tidak dapat dibeli dan dilihat.'],
      },
      require_delivery_insurance: {
        title: 'Asuransi Pengiriman',
        description: [
          'Menanggung pengembalian dana produk & ongkir untuk penjual maupun pembeli jika terjadi kerusakan / kehilangan saat pengiriman.',
          'Saat ini hanya tersedia bagi pengiriman pada kurir <b>JNE</b> dengan metode Pickup.',
        ],
      },
      is_registry_only: {
        title: 'Khusus Registry',
        description: [
          'Produk ini hanya ditampilkan di halaman registry.',
        ],
      },
      preorder_days: {
        title: 'Pre-Order',
        description: [
          'Produk ini dapat diproses hingga 28 hari sebelum dikirim.',
        ],
      },
    },
    statusOptions: [
      { label: 'Semua', key: null, value: null },
      { label: 'Non URL Afiliasi', key: 'has_unchanged_url', value: true },
      { label: 'Sudah terbeli', key: 'is_purchase_true', value: true },
      { label: 'Belum dibeli', key: 'is_purchase', value: false },
    ],
  }),

  getters: {
    switchStep: state => {
      const data = state.switchExternal
      if (!data.product && !data.variant) return 1
      if (data.product && !data.variant) return 2
      return 0
    },
    switchPickedProduct: state => state.switchExternal.product,
    productStep: state => {
      if (state.product) return state.product.step
      return 0
    },
    productVariantWithOutTable: state => {
      if (state.product) {
        if (state.product.variants.length && state.product.variants[0].variant === '') {
          return this.state.product.variants[0]
        }
        return ''
      }
      return ''
    },
    productVariantWithTable: state => {
      if (state.product) {
        if (state.product.variants.length && state.product.variants[0].variant !== '') {
          return this.state.product.variants
        }
        return []
      }
      return []
    },
    productsList: state => {
      const products = []
      state.products.rows.forEach(el => {
        products.push({
          id: el.id,
          name: el.name,
          images: el.images.length ? el.images[0] : null,
          merchant: el.merchant.name,
        })
      })
      return products
    },
  },

  mutations: {
    SET_PRODUCTS(state, payload) {
      state.products = payload
    },
    SET_PRODUCT(state, payload) {
      state.product = payload
    },
    SET_EMPTY_PRODUCTS(state, payload) {
      state.emptyProducts = payload
    },
    SET_PRODUCT_STOCKS(state, payload) {
      state.productStocks = payload
    },
    SET_PRODUCT_REGISTRIES(state, payload) {
      state.productRegistries = payload
    },
    SET_PRODUCT_EXTERNAL(state, payload) {
      state.externalProducts = payload
    },
    SET_LOADING(state, value) {
      state.isLoading = value
    },
    SET_LOADING_SUBMIT(state, value) {
      state.isLoadingSubmit = value
    },
    SET_LOADING_DASHBOARD(state, value) {
      state.isLoadingDashboard = value
    },
    SET_OPEN_EDIT(state, value) {
      state.isShowEditProductExternal = value
    },
    SET_OPEN_SWITCH(state, value) {
      state.isShowSwitchProductExternal = value
    },
    SET_OPEN_DO_NOT_SWITCH(state, value) {
      state.isShowDoNotSwitchProductExternal = value
    },
    SET_PRODUCT_GROWTH(state, payload) {
      state.productGrowth = payload
    },
    SET_SKU_GROWTH(state, payload) {
      state.skuGrowth = payload
    },
    SET_EMPTY_RESULT_SEARCH(state, payload) {
      state.emptyResultSearch = payload
    },
    SET_TOP_SEARCH(state, payload) {
      state.topSearch = payload
    },
    SET_TOP_RESULT(state, payload) {
      state.topResult = payload
    },
    SET_SWITCH_PRODUCT(state, payload) {
      state.switchExternal.product = payload
    },
    SET_SWITCH_VARIANT(state, payload) {
      state.switchExternal.variant = payload
    },
    RESET_SWITCH(state) {
      state.switchExternal = {
        product: '',
        variant: '',
      }
    },
    SET_PRODUCT_SEARCH(state, payload) {
      state.productsSearch = payload
    },
    PUSH_PRODUCT_SEARCH(state, payload) {
      state.productsSearch.push(...payload)
    },
    SET_PRODUCT_SEARCH_META(state, payload) {
      state.productsMetaSearch = payload
    },
    RESET_PRODUCT_SEARCH_META(state) {
      state.productsMetaSearch = {}
    },
    RESET_PRODUCT_SEARCH(state) {
      state.productsSearch = []
    },
    SET_START_INDEX(state, payload) {
      state.startIndex = payload
    },
    SET_SKUS(state, payload) {
      state.skus = payload
    },
    RESET_PRODUCT_LIST(state) {
      state.products = {
        rows: [],
        links: {},
        pagination: {},
      }
    },
  },

  actions: {
    async getProducts({ commit }, { page = null, limit = null, keyword = '' } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = '/v1/admin/products?sort=-created_at'

        const response = await this._vm.$http.get(url, {
          params:
          {
            page,
            limit,
            'filter[keyword]': keyword,
          },
        })

        const mappedData = response.data
        if (mappedData && mappedData.data) {
          mappedData.data = mappedData.data.map(product => ({
            ...product,
            variants: (product.variants || []).map(variant => {
              const oldPrice = Number(variant.old_price || 0)
              return {
                ...variant,
                originalPrice: oldPrice > 0 ? oldPrice : Number(variant.price),
                discountedPrice: oldPrice > 0 ? Number(variant.price) : null,
              }
            }),
          }))
        }

        commit('SET_PRODUCTS', mappedData)
        commit('SET_LOADING', false)

        return mappedData
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    async getEmptyProducts({ commit }, { page = null, limit = null } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = '/v1/admin/products?sort=-created_at&filter[stock_status]=empty'

        const response = await this._vm.$http.get(url, { params: { page, limit } })

        commit('SET_EMPTY_PRODUCTS', response.data)
        commit('SET_LOADING', false)

        return response.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    async getProductStocks({ commit }, { page = null, limit = null, keyword = undefined } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = '/v1/admin/skus'

        const response = await this._vm.$http.get(url, {
          params: {
            page, limit, 'filter[keyword]': keyword, sort: '-created_at',
          },
        })

        commit('SET_PRODUCT_STOCKS', response.data)
        commit('SET_LOADING', false)

        return response.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    async getProductRegistries({ commit }, { page = null, limit = null } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = '/v1/admin/products?filter[has_registry_users]=true&sort=-registry_count'

        const response = await this._vm.$http.get(url, { params: { page, limit } })

        commit('SET_PRODUCT_REGISTRIES', response.data)
        commit('SET_LOADING', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    async getProductExternal({ commit, state }, {
      page = 1,
      limit = 20,
      sort = '-created_at',
      status = '',
      keyword = '',
    } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = '/v1/admin/gifts/external-products'
        let statused = state.statusOptions[0]

        if (status) {
          statused = state.statusOptions.find(el => el.key === status)
        }

        if (status === 'is_purchase_true') {
          statused = { label: 'Sudah terbeli', key: 'is_purchase', value: true }
          // eslint-disable-next-line no-param-reassign
          sort = '-updated_at'
        }

        const response = await this._vm.$http.get(url, {
          params: {
            page,
            limit,
            sort,
            [`filter[${statused.key}]`]: statused.value,
            'filter[keyword]': keyword,
          },
        })

        commit('SET_PRODUCT_EXTERNAL', response.data)
        commit('SET_LOADING', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    async updateUrlProductExternal({ commit }, value) {
      try {
        commit('SET_LOADING', true)
        const url = `v1/admin/gifts/external-product/${value.data.id}`

        const response = await this._vm.$http.put(url, { url: value.url })
        commit('SET_LOADING', false)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah URL Produk!',
        }, { root: true })

        commit('SET_OPEN_EDIT', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING', false)
        commit('response/SET_ERROR', {
          message: 'Error!',
        }, { root: true })
        return error
      }
    },
    async getProductGrowth({ commit }, {
      startMonth = null, endMonth = null, startYear = null, endYear = null,
    }) {
      try {
        commit('SET_LOADING_DASHBOARD', true)
        const startReport = `${startYear}-${startMonth}`
        const endReport = `${endYear}-${endMonth}`

        const endDateMonth = moment(endReport).endOf('month').format('YYYY-MM-DD')
        const startDateMonth = moment(startReport).startOf('month').format('YYYY-MM-DD')

        const endDate = `filter[end_date]=${endDateMonth}`
        const startDate = `filter[start_date]=${startDateMonth}`

        const url = `/v1/backoffice/diagram/product_creation?${startDate}&${endDate}`

        const response = await this._vm.$http.get(url)

        commit('SET_PRODUCT_GROWTH', response.data.data)
        commit('SET_LOADING_DASHBOARD', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING_DASHBOARD', false)
        throw new Error(error)
      }
    },
    async getSkuGrowth({ commit }, {
      startMonth = null, endMonth = null, startYear = null, endYear = null,
    }) {
      try {
        commit('SET_LOADING_DASHBOARD', true)
        const startReport = `${startYear}-${startMonth}`
        const endReport = `${endYear}-${endMonth}`

        const endDateMonth = moment(endReport).endOf('month').format('YYYY-MM-DD')
        const startDateMonth = moment(startReport).startOf('month').format('YYYY-MM-DD')

        const endDate = `filter[end_date]=${endDateMonth}`
        const startDate = `filter[start_date]=${startDateMonth}`

        const url = `/v1/backoffice/diagram/sku_creation?${startDate}&${endDate}`

        const response = await this._vm.$http.get(url)

        commit('SET_SKU_GROWTH', response.data.data)
        commit('SET_LOADING_DASHBOARD', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING_DASHBOARD', false)
        return error
      }
    },
    async getEmptyResultsSearch({ commit }, {
      startMonth = null, endMonth = null, startYear = null, endYear = null,
    }) {
      try {
        commit('SET_LOADING_DASHBOARD', true)
        const startReport = `${startYear}-${startMonth}`
        const endReport = `${endYear}-${endMonth}`

        const endDateMonth = moment(endReport).endOf('month').format('YYYY-MM-DD')
        const startDateMonth = moment(startReport).startOf('month').format('YYYY-MM-DD')

        const endDate = `filter[end_date]=${endDateMonth}`
        const startDate = `filter[start_date]=${startDateMonth}`

        const url = `/v1/admin/algolia/search-not-found?${startDate}&${endDate}`

        const response = await this._vm.$http.get(url)

        commit('SET_EMPTY_RESULT_SEARCH', response.data.data)
        commit('SET_LOADING_DASHBOARD', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING_DASHBOARD', false)
        return error
      }
    },
    async getTopSearch({ commit }, {
      startMonth = null, endMonth = null, startYear = null, endYear = null,
    }) {
      try {
        commit('SET_LOADING_DASHBOARD', true)
        const startReport = `${startYear}-${startMonth}`
        const endReport = `${endYear}-${endMonth}`

        const endDateMonth = moment(endReport).endOf('month').format('YYYY-MM-DD')
        const startDateMonth = moment(startReport).startOf('month').format('YYYY-MM-DD')

        const endDate = `filter[end_date]=${endDateMonth}`
        const startDate = `filter[start_date]=${startDateMonth}`

        const url = `/v1/admin/algolia/top-search?${startDate}&${endDate}`

        const response = await this._vm.$http.get(url)

        commit('SET_TOP_SEARCH', response.data.data ? response.data.data : [])
        commit('SET_LOADING_DASHBOARD', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING_DASHBOARD', false)
        return error
      }
    },
    async getTopResult({ commit }, {
      startMonth = null, endMonth = null, startYear = null, endYear = null,
    }) {
      try {
        commit('SET_LOADING_DASHBOARD', true)
        const startReport = `${startYear}-${startMonth}`
        const endReport = `${endYear}-${endMonth}`

        const endDateMonth = moment(endReport).endOf('month').format('YYYY-MM-DD')
        const startDateMonth = moment(startReport).startOf('month').format('YYYY-MM-DD')

        const endDate = `filter[end_date]=${endDateMonth}`
        const startDate = `filter[start_date]=${startDateMonth}`

        const url = `/v1/admin/algolia/top-result?${startDate}&${endDate}`

        const response = await this._vm.$http.get(url)

        commit('SET_TOP_RESULT', response.data.data ? response.data.data : [])
        commit('SET_LOADING_DASHBOARD', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING_DASHBOARD', false)
        return error
      }
    },
    // create & update product
    async createProduct({ commit }, { id = null, data }) {
      try {
        const url = '/v1/admin/products'

        const response = await this._vm.$http.post(url, {
          id,
          merchant_id: data.merchant?.id,
          images: data.imagesId,
          name: data.name,
          keyword: data.keyword,
          category_id: data.category.id,
          is_active: data.is_active,
          condition: data.condition,
          description: data.description,
          require_delivery_insurance: data.require_delivery_insurance,
          is_registry_only: data.is_registry_only,
          // `preorder_days` is intentionally omitted here: it is a derived field
          // kept in sync from the active variants (SkuObserver). Sending it from
          // the product-info step would reset the product-level value to null.
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Produk!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Produk!',
        }, { root: true })
        throw new Error(error)
      }
    },
    async uploadImage({ commit }, data) {
      try {
        const url = '/v1/admin/upload/image'

        const formData = new FormData()
        formData.append('image', data)

        const response = await this._vm.$http.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Foto!',
        }, { root: true })

        return error
      }
    },
    async getProduct({ commit }, id) {
      try {
        const url = `/v1/admin/products/${id}`

        const response = await this._vm.$http.get(url)

        // if (response.data.data.step === 3) {
        //   commit('SET_START_INDEX', 0)
        // } else {
        //   commit('SET_START_INDEX', response.data.data.step)
        // }

        const productData = response.data.data
        if (productData && productData.variants && productData.variants.length) {
          productData.variants = productData.variants.map(variant => {
            const oldPrice = Number(variant.old_price || 0)
            return {
              ...variant,
              originalPrice: oldPrice > 0 ? Number(oldPrice) : Number(variant.price),
              discountedPrice: oldPrice > 0 ? Number(variant.price) : null,
            }
          })
        }

        commit('SET_PRODUCT', productData)

        return productData
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Produk!',
        }, { root: true })

        throw new Error(error)
      }
    },
    async getSkuByBarcode({ state, commit }, barcode) {
      try {
        const url = `/v1/admin/skus/barcode/${barcode}`

        const response = await this._vm.$http.get(url)

        const { skus } = state

        // if exists
        if (skus.find(item => item.barcode === response.data.data.barcode)) {
          commit('response/SET_ERROR', {
            message: 'Produk sudah ditambahkan.',
          }, { root: true })

          return response.data.data
        }

        commit('SET_SKUS', [...skus, {
          ...response.data.data,
          add_stock: 1, // initial
          new_stock: response.data.data.stock + 1, // initial
        }])

        return response.data.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Produk tidak ditemukan.',
        }, { root: true })

        throw new Error(error)
      }
    },
    async updateProductVariant({ commit }, { data, id }) {
      try {
        const url = `/v1/admin/products/${id}`

        // Map BE price/old_price → FE alias originalPrice/discountedPrice
        const convertVariant = variant => {
          // Exclude FE-only aliases before sending to BE
          const { originalPrice, discountedPrice, ...rest } = variant
          const discounted = Number(discountedPrice || 0)
          const original = Number(originalPrice || 0)
          return {
            ...rest,
            price: discounted > 0 ? discounted : original,
            old_price: discounted > 0 ? original : null,
          }
        }

        const payload = { ...data }

        // Automatically align preorder payload for multi-variant products
        if (payload.variants && payload.variants.length) {
          const allPreorderDays = payload.variants.map(v => v.preorder_days)
          const allSame = allPreorderDays.length > 0 && allPreorderDays.every(val => val === allPreorderDays[0])
          if (allSame && allPreorderDays[0] !== null && allPreorderDays[0] !== undefined) {
            payload.preorder_days = Number(allPreorderDays[0])
            payload.variants = payload.variants.map(v => ({
              ...v,
              preorder_days: Number(allPreorderDays[0]),
            }))
          } else {
            payload.preorder_days = null
          }
        }

        // Single variant: map root-level alias to BE fields (only if values are set)
        if (payload.originalPrice != null || payload.discountedPrice != null) {
          const discounted = Number(payload.discountedPrice || 0)
          const original = Number(payload.originalPrice || 0)
          payload.price = discounted > 0 ? discounted : original
          payload.old_price = discounted > 0 ? original : null
        }
        delete payload.originalPrice
        delete payload.discountedPrice

        // Multi variant: map each variant alias to BE fields
        if (payload.variants && payload.variants.length) {
          payload.variants = payload.variants.map(convertVariant)
        }

        const response = await this._vm.$http.put(url, payload)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Varian Produk!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Varian Produk!',
        }, { root: true })

        throw new Error(error)
      }
    },
    async updateProductRecomendation({ commit }, { data, id, isEdit }) {
      try {
        const url = `/v1/admin/products/${id}/finish`
        const response = await this._vm.$http.put(url, data)

        commit('response/SET_SUCCESS', {
          message: `Berhasil ${isEdit ? 'Mengubah' : 'Menambahkan'} Rekomendasi Produk!`,
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Rekomendasi Produk!',
        }, { root: true })

        throw new Error(error)
      }
    },
    async switchProductExternal({ commit }, { idProduct = null, skuId = null }) {
      try {
        commit('SET_LOADING_SUBMIT', true)
        const url = `/v1/admin/change-product/${idProduct}`
        const response = await this._vm.$http.put(url, {
          sku_id: skuId,
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Produk!',
        }, { root: true })
        commit('SET_LOADING_SUBMIT', false)

        return response.data
      } catch (error) {
        commit('SET_LOADING_SUBMIT', false)
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Produk!',
        }, { root: true })

        throw new Error(error)
      }
    },
    async searchProducts({ commit }, {
      filter = null, limit = 5, keyword = null, loadMore = false, page = 1,
    } = {}) {
      try {
        const url = '/v5/products'

        const response = await this._vm.$http.get(url, {
          params: {
            ...filter, page, limit, keyword, sort: !keyword ? '-created_at' : undefined,
          },
        })

        if (!loadMore) {
          commit('SET_PRODUCT_SEARCH', response.data.data.rows)
        } else {
          commit('SET_PRODUCT_SEARCH_META', response.data.data.pagination)
          commit('PUSH_PRODUCT_SEARCH', response.data.data.rows)
        }

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Error!',
        }, { root: true })
        return error
      }
    },
    async switchProductMerchant({ commit }, { merchantId = null, productId = null }) {
      try {
        commit('SET_LOADING_SUBMIT', true)
        const url = '/v1/admin/products/transfer'
        const response = await this._vm.$http.post(url, {
          merchant_id: merchantId,
          product_id: productId,
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Merchant!',
        }, { root: true })
        commit('SET_LOADING_SUBMIT', false)

        return response.data
      } catch (error) {
        commit('SET_LOADING_SUBMIT', false)
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Merchant!',
        }, { root: true })

        throw new Error(error)
      }
    },
  },
}
